module.exports = __webpack_public_path__ + "static/media/BetterGroceriesAdmin.c94c6820.png";